import React from 'react';
import { useRole } from '../context/RoleContext';
import { useChat } from '../context/ChatContext';
import ChatComposer from './ChatComposer';
import ChatView from './ChatView';

const CenterHome = () => {
  const { isProfessor, currentUser } = useRole();
  const { messages, selectedSubject } = useChat();
  
  const firstName = currentUser?.name ? currentUser.name.split(' ')[0] : 'Estudiante';
  
  const welcomeText = isProfessor 
    ? '¡Hola, Dra. María!'
    : `¡Hola, ${firstName}!`;
  
  const subtitleText = isProfessor
    ? '¿Qué deseas gestionar hoy?'
    : '¿En qué puedo ayudarte hoy?';

  const hasMessages = messages.length > 0;

  return (
    <div className={`flex flex-col h-full ${isProfessor ? 'dark-content' : ''}`} data-testid="center-home">
      {/* Main Content Area */}
      {hasMessages ? (
        // Chat View
        <ChatView />
      ) : (
        // Welcome Screen
        <div className="flex-1 flex flex-col items-center justify-center text-center pt-4 pb-8 min-h-0 px-4">
          {/* Welcome Text */}
          <h1 
            className={`text-2xl md:text-3xl font-medium mb-2 ${
              isProfessor ? 'text-white' : 'text-gray-800'
            }`}
            data-testid="welcome-title"
          >
            {welcomeText}
          </h1>
          <p className={`text-sm md:text-base mb-6 ${isProfessor ? 'text-gray-400' : 'text-gray-500'}`} data-testid="welcome-subtitle">
            {subtitleText}
          </p>
          
          {/* Subject Info Card - Only show if a specialized subject is selected */}
          {selectedSubject && selectedSubject.id !== 'default' && (
            <div className={`max-w-md mx-auto p-4 rounded-xl ${
              isProfessor 
                ? 'bg-gray-800/50 border border-gray-700' 
                : 'bg-white/70 border border-gray-100 shadow-sm'
            }`}>
              <div className="flex items-center gap-3 mb-2">
                {selectedSubject.icon_url && (
                  <img 
                    src={selectedSubject.icon_url} 
                    alt={selectedSubject.name}
                    className="w-10 h-10 object-contain"
                  />
                )}
                <div className="text-left">
                  <h3 className={`font-medium ${isProfessor ? 'text-white' : 'text-gray-800'}`}>
                    {selectedSubject.name}
                  </h3>
                  <p className={`text-xs ${isProfessor ? 'text-gray-400' : 'text-gray-500'}`}>
                    {selectedSubject.description}
                  </p>
                </div>
              </div>
              <p className={`text-xs ${isProfessor ? 'text-gray-500' : 'text-gray-400'}`}>
                {isProfessor 
                  ? 'Escribe tu consulta para recibir asistencia pedagógica especializada.'
                  : 'Escribe tu pregunta y te ayudaré a aprender sobre este tema.'
                }
              </p>
            </div>
          )}
        </div>
      )}
      
      {/* Chat Composer */}
      <ChatComposer />
    </div>
  );
};

export default CenterHome;
